import Errors from "./Errors";

export default class Form {
    /**
     * Create a new Form instance.
     *
     * @param {object} data
     */
    constructor(data, options) {
        this.originalData = data;
        this.is_loading = false;

        for (let field in data) {
            this[field] = data[field];
        }

        let defaults = {
            displayErrorMessage: true,
            displaySuccessMessage: false,
            reset: false,
            redirect: false,
            delay: 1500,
            stop: true
        };
        this.options = Object.assign({}, defaults, options);

        this.errors = new Errors();
    }

    /**
     * Fetch all relevant data for the form.
     */
    data() {
        let data = {};

        for (let property in this.originalData) {
            data[property] = this[property];
        }

        return data;
    }

    /**
     * Return the form's data as a FormData instance.
     */
    asFormData(except = []) {
        let data = this.data();
        let formData = new FormData();
        
        for ( let key in data ) {
            if ( ! except || ! except.includes(key) ) {
                formData.append(key, data[key]);
            }
        }

        return formData;
    }

    /**
     * Fetch all fields (data keys) of the form.
     */
    fields() {
        let fields = [];

        for (let property in this.originalData) {
            fields.push(property);
        }

        return fields;
    }

    /**
     * Fill the original properties of the form from the object or array given.
     */
    fill(data) {
        for (let property in this.originalData) {
            this[property] = data[property];
        }
    }


    /**
     * Reset the form fields.
     */
    reset() {
        for (let field in this.originalData) {
            this[field] = this.originalData[field];
        }

        this.errors.clear();
        this.stop();
    }


    /**
     * Send a POST request to the given URL.
     * .
     * @param {string} url
     */
    post(url, data, extras) {
        return this.submit('post', url, data, extras);
    }


    /**
     * Send a PUT request to the given URL.
     * .
     * @param {string} url
     */
    put(url, data, extras) {
        return this.submit('put', url, data, extras);
    }


    /**
     * Send a PATCH request to the given URL.
     * .
     * @param {string} url
     */
    patch(url, data, extras) {
        return this.submit('patch', url, data, extras);
    }


    /**
     * Send a DELETE request to the given URL.
     * .
     * @param {string} url
     */
    delete(url, data, extras) {
        return this.submit('delete', url, data, extras);
    }


    /**
     * Submit the form.
     *
     * @param {string} requestType
     * @param {string} url
     */
    submit(requestType, url, data, extras) {
        if ( ! data ) {
            data = this.data();
        }

        this.load();
        return new Promise((resolve, reject) => {
            axios[requestType](url, data, extras)
                .then(response => {
                    this.onSuccess(response.data);

                    resolve(response.data);
                })
                .catch(error => {
                    if (error.response && error.response.data) {
                        this.onFail(error.response.data);
                    }

                    if ( error.response && error.response.data ) {
                        reject(error.response.data);
                    } else {
                        reject(error);
                    }
                });
        });
    }


    /**
     * Handle a successful form submission.
     *
     * @param {object} data
     */
    onSuccess(data) {
        if ( this.options.displaySuccessMessage && typeof data.message !== 'undefined' ) {
            window.Toasteo.success(data.message);
        }
        
        if (this.options.stop) {
            this.stop();
        }
        this.errors.clear();
        if (this.options.reset) {
            this.reset();
        }
    }


    /**
     * Handle a failed form submission.
     *
     * @param {object} errors
     */
    onFail(data) {
        if ( this.options.displayErrorMessage && typeof data.message !== 'undefined' ) {
            window.Toasteo.error(data.message);
        }

        this.stop();

        if ( typeof data.errors !== 'undefined' ) {
            this.errors.record(data.errors);
        }
    }

    /**
     * 
     */
    redirectTo(url) {
        if (this.options.redirect && url) {
            redirectTo(url, this.options.delay);
        }
    }

    /**
     * Start the form loading.
     */
    load() {
        this.is_loading = true;
    }

    /**
     * Stop the form loading.
     */
    stop() {
        this.is_loading = false;
    }

    /**
     * Check if the form is currently loading.
     */
    isLoading() {
        return this.is_loading;
    }
    
}
